var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDownload = function SvgIconDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_download_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_download_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M9.996 12.688a.756.756 0 0 1-.281-.053.691.691 0 0 1-.236-.156L6.521 9.521a.688.688 0 0 1-.219-.53.788.788 0 0 1 .77-.762.73.73 0 0 1 .532.23l1.646 1.666V3.75c0-.212.071-.39.214-.534A.72.72 0 0 1 9.996 3c.21 0 .39.072.535.216a.72.72 0 0 1 .219.534v6.375l1.667-1.667a.676.676 0 0 1 .527-.218.808.808 0 0 1 .545.24.745.745 0 0 1-.01 1.062l-2.958 2.937a.756.756 0 0 1-.525.208ZM5.494 16c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 0 1 4 14.5v-.75c0-.213.071-.39.214-.534A.72.72 0 0 1 4.746 13c.21 0 .39.072.535.216a.72.72 0 0 1 .219.534v.75h9v-.75c0-.213.072-.39.214-.534a.72.72 0 0 1 .532-.216c.21 0 .39.072.535.216a.72.72 0 0 1 .219.534v.75c0 .412-.147.766-.44 1.06-.295.293-.648.44-1.06.44H5.493Z"
  }))));
};
export default SvgIconDownload;